export const appConfig = {
  version: '0.4.1',
  projectName: 'AskAltronic',
};

// File extensions to show in source cards and the sources sidebar.
// Only files whose extension is in this list will be displayed.
export const VISIBLE_SOURCE_EXTENSIONS = ['.pdf'];

export default appConfig;
